import { TrainIdentifier } from "@vygruppen/vy-train-map";
import { PreviewResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/utils";
import { TrainEventTypeEnum } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/types/trainEventTypeEnum";
import { partition } from "shared/utils/arrayUtils";

export type TrainResumedResponse = {
  trainsResumed: TrainResumed[];
  action: "ADD" | "REMOVE";
};

export type TrainResumed = {
  trainIdentifier: TrainIdentifier;
  affectedStopName: string;
  originStopName: string;
  destinationStopName: string;
  actualTime: string;
  scheduledTime: string;
  trainInformationUuid: string | null;
  trainInformationSummary: string;
  preview: PreviewResponse;
  eventType:
    | TrainEventTypeEnum.TRAIN_STOPPED
    | TrainEventTypeEnum.TRAIN_DELAY_EXPECTED;
};

const findMatch = (list: TrainResumed[], item: TrainResumed) =>
  list.find((it) => item.trainInformationUuid === it.trainInformationUuid);

const mergeData = (oldData: TrainResumed[], updatedData: TrainResumed[]) => {
  oldData.forEach((oldTrainResumed) => {
    const updatedTrainResumed = findMatch(updatedData, oldTrainResumed);
    if (updatedTrainResumed) {
      Object.assign(oldTrainResumed, updatedTrainResumed);
    }
  });
  return oldData;
};

export function handleTrainResumedResponse(
  data: TrainResumedResponse,
  trainsResumed: TrainResumed[],
  setTrainsResumed: (value: TrainResumed[]) => void,
) {
  if (data.action === "ADD") {
    const [updatedData, newData] = partition(
      data.trainsResumed,
      (trainResumed) => !!findMatch(trainsResumed, trainResumed),
    );
    setTrainsResumed([...mergeData(trainsResumed, updatedData), ...newData]);
  } else if (data.action === "REMOVE") {
    setTrainsResumed(
      trainsResumed.filter(
        (it) =>
          it.trainInformationUuid !==
          data.trainsResumed[0].trainInformationUuid,
      ),
    );
  }
}
